import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { dateformat } from 'src/app/models/commonModel';
import { OrdinalDatePipe } from 'src/app/services/common/ordinal-date.pipe';
import { SharedService } from 'src/app/services/shared-service/shared.service';

@Component({
    selector: 'app-freeze-session-conflicts',
    templateUrl: './freeze-session-conflicts.component.html',
    styleUrls: ['./freeze-session-conflicts.component.scss'],
    standalone: false
})
export class FreezeSessionConflictsComponent {

  // Common Properties
  displayedColumns: string[] = [
    'Name',
    'Date',
    'Time',
    'ErrorMessage'
  ];
  dataSource = new MatTableDataSource<any>([]);
  showData: boolean = false;
  dateFormat: {
    datetime: string; titleFormat: string;
    date: string; shortTime: string;
    dateRangeTime: string
  };
  conflictsData: any;

  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<FreezeSessionConflictsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { conflictsData: any }
  ) {
    this.conflictsData = data.conflictsData;
  }

  ngOnInit() {
    this.dateFormat = dateformat;
    this.getConflictList();
  }

  getConflictList() {
    let records = [];
    this.conflictsData.forEach(element => {
      records.push({
        StartDate : element.freezeStartTime,
        EndDate: element.freezeEndTime,
        ErrorMessage: element.errorMessage ? element.errorMessage : "",
        UserName: element.userName
      });
    });
    this.dataSource = new MatTableDataSource<any>(records);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}